import { Package } from "lucide-react";

const EmptyState = () => (
  <div className="bg-neutral-50 py-16 text-center">
    <Package className="mx-auto mb-4 h-12 w-12 text-neutral-400" />
    <h3 className="mb-1 text-lg font-medium text-neutral-900">
      Nenhum registro encontrado
    </h3>
    <p className="text-neutral-500">Não há dados para exibir no momento.</p>
  </div>
);

export default EmptyState;
